import { Bloc } from "./bloc.model";
import { Infant } from "./infant.model";
import { Observacio } from "./observacio.model";
import { ResponseValoracio } from "./response_valoracio.model";

export class ResponseQuestionari {
    blocs: Array<Bloc> = [];
    idAmbit: number;
    infant: Infant;
    nomAmbit: string;
    observacionsProposades: Array<Observacio> = [];
    respostesValoracions: ResponseValoracio;
}